import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

type AppState = {
  loading: boolean;
};

const initialState: AppState = {
  loading: false,
};

export const AppStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    setLoading(isLoading: boolean): void {
      patchState(store, { loading: isLoading });
    },
    startLoading(): void {
      patchState(store, { loading: true });
    },
    stopLoading(): void {
      patchState(store, { loading: false });
    },
  }))
);
